import React, { useState, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  TextField,
  makeStyles,
  createStyles,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import User from "../../auth/User";
import PasswordField from "../common/PasswordField";
import { delayPush } from "../../helper/Util";
import { useStateSafe } from "../../helper/customHook";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "calc(100vh - 58px)", // topbarの高さ分を引く(progressBar込み)
      [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
        minHeight: "calc(100vh - 50px)",
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: "calc(100vh - 66px)",
      },
    },
    loginForm: {
      margin: theme.spacing(1),
      width: "75%",
      maxWidth: "350px",
    },
    errorMsg: {
      margin: theme.spacing(1),
      width: "75%",
      height: theme.spacing(8),
      maxWidth: "350px",
      fontSize: 16,
      color: red[800],
    },
    loginButton: {
      width: "100%",
      maxWidth: "350px",
    },
    forgotButton: {
      fontSize: 20,
    },
    wrapLoginButton: {
      width: "75%",
      maxWidth: "350px",
      position: "relative",
      marginBottom: theme.spacing(2),
    },
    progress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -17,
      marginLeft: -12,
    },
  })
);

export default function Login() {
  const history = useHistory();
  const email = useRef("");
  const password = useRef("");
  const [errorMsg, setErrorMsg] = useState("");

  const classes = useStyles();

  const handleChangeEmail = useCallback((e) => {
    email.current = e.target.value;
  }, []);

  const handleChangePassword = useCallback((e) => {
    password.current = e.target.value;
  }, []);

  const [isLoading, setIsLoading] = useStateSafe(false);

  const handleClickLogin = useCallback(async () => {
    setIsLoading(true);

    await User.login(email.current, password.current)
      .then((res) => {
        if (res) history.push("/calendar");
        else setErrorMsg("メールアドレスまたはパスワードが違います");
      })
      .catch((err) => {
        setErrorMsg("メールアドレスまたはパスワードが違います");
      });

    setIsLoading(false);
  }, [history, setIsLoading]);

  const handleClickForgotButton = () => {
    delayPush(history, "/forgot");
  };

  return (
    <div className={classes.root}>
      <TextField
        label="メールアドレス"
        aria-label="メールアドレス"
        type="email"
        className={classes.loginForm}
        onChange={handleChangeEmail}
      />
      <PasswordField
        label="パスワード"
        aria-label="パスワード"
        className={classes.loginForm}
        onChange={handleChangePassword}
      />
      <Typography className={classes.errorMsg}>{errorMsg}</Typography>

      <div className={classes.wrapLoginButton}>
        <Button
          variant="contained"
          color="primary"
          className={classes.loginButton}
          disabled={isLoading}
          disableElevation={isLoading}
          onClick={handleClickLogin}
        >
          ログイン
        </Button>

        {isLoading && (
          <CircularProgress size={34} className={classes.progress} />
        )}
      </div>

      <Button
        variant="text"
        color="primary"
        className={classes.forgotButton}
        onClick={handleClickForgotButton}
      >
        パスワードを忘れた場合
      </Button>
    </div>
  );
}
